import React from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Button } from 'antd'
import SumFooter from '../../../../elements/Table/Footers/SumFooter'
import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'
import { dateMonthFormat, dateVal } from '../../../../modules/Utils'
import { BUDGET_TYPE_SALES } from '../../../../components/Common/Budgets/BudgetCont'

function BudgetLines(props) {
  let columns = [
    {
      Header: 'ID',
      accessor: '_key',
      Cell: ({ value, original }) => (
        <a onClick={(e) => props.linesModal.onShow(original, 'edit')}>{value || original.key}</a>
      ),
    },
    {
      Header: 'Name',
      accessor: 'name',
    },

    {
      Header: 'Period',
      accessor: 'periodDisplay',
      Cell: ({ value }) => value && `${dateMonthFormat(dateVal({ value }, 'value'))}`,
    },
    {
      Header: 'Account',
      accessor: 'account',
      Cell: ({ value }) => `${value.code} - ${value.name}`,
    },
    {
      Header: 'Target',
      accessor: 'target',
      Cell: MoneyCell,
      Footer: SumFooter,
    },

    {
      Header: 'Notes',
      accessor: 'notes',
      hideDefault: true,
      hideable: true,
    },
  ]

  const { option, type, list, isUpdatable, fetching, fetch, onShow } = props
  if (option === BUDGET_TYPE_SALES)
    columns = columns.filter((c) => c.accessor !== 'periodDisplay' && c.accessor !== 'name')
  return (
    <CustomTable
      columns={columns}
      data={list}
      loading={fetching}
      hide={{ refresh: type === 'new' }}
      fetch={fetch}
      CreateButton={() => (
        <Button disabled={!isUpdatable} type={'primary'} size={'small'} icon={'plus'} onClick={onShow}>
          New{' '}
        </Button>
      )}
    />
  )
}

BudgetLines.propTypes = {}
BudgetLines.defaultProps = {}

export default BudgetLines
